import styles from './A_Tag.module.css';
import cn from 'classnames';

interface A_TagProps {
  label: string;
  className?: string;
}

export default function A_Tag({ label, className }: A_TagProps) {
  return (
    <div className={cn(styles.wrapper, className, 'effect-glass')}>
      <span className={cn(styles.label, 'text-caption')}>{label}</span>
    </div>
  );
}
